import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { UpdateProfileDto } from '../types/dtos/update-profile.dto'
import { toFormData } from '@/core/lib/utils/to-form-data'
type UpdateProfilePayload = {
  username: string
  email: string
  birthdate: string | Date
  image?: File
  _method: 'put'
}
export function createUpdateProfileUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (dto: UpdateProfileDto) {
    const { token } = await tokenService.getToken()

    if (!token) {
      throw new UnauthorizedError()
    }
    const payload: UpdateProfilePayload = {
      email: dto.email,
      username: dto.username,
      birthdate: dto.birthdate,
      _method: 'put',
    }

    if (dto.image instanceof File) {
      payload.image = dto.image
    }
    const res = await httpClient
      .version('v1')
      .addHeaders(AUTH_HEADER(token))
      .post('/website/buyer/update/profile', toFormData(payload))
    return res.data
  }
}
